import { render } from "./SafeFooter.vue?vue&type=template&id=0d2ee457&scoped=true"
import script from "./SafeFooter.vue?vue&type=script&lang=js"
export * from "./SafeFooter.vue?vue&type=script&lang=js"

import "./SafeFooter.vue?vue&type=style&index=0&id=0d2ee457&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2ee457"]])

export default __exports__